<template>
  <div class="location-container">
    <div v-if="location">
      <h4>Details for {{ location.title }}</h4>
      <b-form>
        <b-form-group>
          <label for="title">Title</label>
          <b-form-input id="title" v-model="location.title">{{
            location.title
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="street">Street</label>
          <b-form-input id="street" v-model="location.street">{{
            location.street
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="city">City</label>
          <b-form-input id="city" v-model="location.city">{{
            location.city
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="state">State</label>
          <b-form-input id="state" v-model="location.state">{{
            location.state
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="zip">Zip Code</label>
          <b-form-input id="zip" v-model="location.zip">{{
            location.zip
          }}</b-form-input>
        </b-form-group>
        <loading-panel :loading="loading" class="text-center py-3">
          <button class="btn btn-primary w-25" @click.prevent="save">
            Save
          </button>
        </loading-panel>
      </b-form>
    </div>
    <div v-else>Please select a location.</div>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
export default {
  name: "location",
  props: {
    location: {},
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
  }),
  methods: {
    async save() {
      try {
        this.loading = true;
        const response = await this.$web.updateLocation(this.location);
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    console.log(this.location);
  },
};
</script>

<style scoped>
.location-container {
  padding: 20px;
}
</style>
